import React from "react"
import { Modal, Form, Button, Spinner, Col } from "react-bootstrap"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import DualListBox from "../../components/Administration/DualListBox"
import ActionButton from "../ActionButton"
import { ValidateConsortiumCompanyObservable } from "../../api/Randoms/ConsortiumData"
import { Subscription } from "rxjs"
import { toast } from "react-toastify"
import { APIError } from "../../api/ObservableFromFetch"

interface CompanySelectionProps {
  companies: AutoFilterCompany[]
  selectedCompanies: AutoFilterCompany[]
  show: boolean
  onSave: (companies: AutoFilterCompany[]) => void
  onClose: () => void
  isConsortium?: boolean
  poolID: number
}

interface CompanySelectionState {
  selectedCompanies: AutoFilterCompany[]
  validations: CompanyValidation[]
  validating: boolean
  showModal: boolean
  validationMessage: string
}

interface CompanyValidation{
  poolID: number
  accountID: number
  message: string
}

export default class CompanySelection extends React.PureComponent<CompanySelectionProps, CompanySelectionState> {
  state: CompanySelectionState = {
    selectedCompanies: [],
    validations: [],
    validating: false,
    showModal: false,
    validationMessage: ""
  }

  subscriptions = new Subscription()
  validateSubscription?: Subscription

  componentDidMount() {
    this.setState({ selectedCompanies: [...this.props.selectedCompanies] })
    if (!!this.props.isConsortium) {
      const datStr = localStorage.getItem("consortiumCheckCompanies");
      if (datStr) {
        const data: CompanyValidation[] = JSON.parse(datStr)
        if (data.length > 0) {
          this.setState({validations: data})
        }
      }
      else {
        this.setState({validations: []})
      }
    }
  }

  componentWillUnmount() {
    if (!!this.props.isConsortium) {
      localStorage.setItem("consortiumCheckCompanies", JSON.stringify(this.state.validations))
    }
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  onChange = (selected: AutoFilterCompany[]) => {
    const { selectedCompanies } = this.state
    if (this.props.isConsortium && selected.length > selectedCompanies.length) {
      this.setState({showModal: true, validating: true})
      const diff = selected.find(x => !this.state.selectedCompanies.find(el => el.AccountID === x.AccountID))
      if (diff) {
        this.validate(diff, selected)
      }
    }
    else {
      this.setState({ selectedCompanies: [...selected] })
    }
  }

  validate = (account: AutoFilterCompany, selected: AutoFilterCompany[]) =>
  {
    ValidateConsortiumCompanyObservable(this.props.poolID, account.AccountID).subscribe(
      (message) => {
        let validations = [...this.state.validations]
        if (message.length === 0) {
          let vs = validations.findIndex(v => v.poolID === this.props.poolID && v.accountID === account.AccountID)
          if(vs >= 0)
          {
            validations.splice(vs, 1)
          }
          this.setState({ selectedCompanies: [...selected], showModal: false })
        }
        else 
        {
          let vs = validations.find(v => v.poolID === this.props.poolID && v.accountID === account.AccountID)
          if (vs !== undefined) {
            vs.message = message
          }
          else {
            validations.push({poolID: this.props.poolID, accountID: account.AccountID, message: message})
          }
        }
        this.setState({ validating: false, validationMessage: message, validations: [...validations ] })
      },
      (error) => this.handleAPIError(error, {validating: false, showModal: false, validationMessage: ""})
    )
  }

  onCancel = () => this.props.onClose()

  onSubmit = () => this.props.onSave(this.state.selectedCompanies)

  render() {
    let cs = this.props.companies.map(a => {
      let v = this.state.validations.find(v => v.poolID === this.props.poolID && v.accountID === a.AccountID)
      let n = !!v?.message ? `${a.Name} (${v.message})` : a.Name
      return {...a, Name: n} 
    })
    return (<>
      {!this.state.showModal && <Modal backdrop="static" show={this.props.show} size="xl">
        <Modal.Header>
          <Modal.Title className="text-uppercase">Companies</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="px-4">
            <DualListBox
              disabled={false}
              options={cs}
              selected={this.state.selectedCompanies}
              idKey="AccountID"
              labelKey="Name"
              availableTitle="Possible Criteria"
              selectedTitle="Selected Criteria"
              onChange={this.onChange}
              isConsortium={true}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.onCancel} className="px-4">Cancel</Button>
          <ActionButton onClick={this.onSubmit} className="px-4">Save</ActionButton>
        </Modal.Footer>
      </Modal>}
      {this.state.showModal && <Modal backdrop="static" show size="lg">
        <Modal.Header>
          <Modal.Title className="text-uppercase">VALIDATION</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.validating &&
            <Col>
              <Spinner animation="border" variant="secondary" />
            </Col>
          }
           {!this.state.validating &&
            <Col>
              {this.state.validationMessage}
            </Col>
          }
        </Modal.Body>
        <Modal.Footer>
        {!this.state.validating  &&  <Button variant="secondary" onClick={() => this.setState({showModal: false})} className="px-4">OK</Button>}
        </Modal.Footer>
      </Modal>}
      </>
    )
  }
}
